import { render, staticRenderFns } from "./PanelSignature.vue?vue&type=template&id=4ba39006&scoped=true&"
import script from "./PanelSignature.vue?vue&type=script&lang=js&"
export * from "./PanelSignature.vue?vue&type=script&lang=js&"
import style0 from "./PanelSignature.vue?vue&type=style&index=0&id=4ba39006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba39006",
  null
  
)

export default component.exports